import { render, staticRenderFns } from "./MigrationNoticeDialogUS.vue?vue&type=template&id=19c461f1&scoped=true&"
import script from "./MigrationNoticeDialogUS.vue?vue&type=script&lang=js&"
export * from "./MigrationNoticeDialogUS.vue?vue&type=script&lang=js&"
import style0 from "./MigrationNoticeDialogUS.vue?vue&type=style&index=0&id=19c461f1&scoped=true&lang=css&"
import style1 from "./MigrationNoticeDialogUS.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c461f1",
  null
  
)

export default component.exports